import React from 'react'

function CustomImage({src, ...props}) {
  return (
    <img src={src} {...props} />
  )
}

export default CustomImage